<template>
  <div>
    <div class="row gutters-tiny">
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="orders" label="Bestellingen" icon="basket"></tile>
      </div>
        <div class="col-6 col-md-4 col-xl-2">
        <tile route="refunds" label="Retouren" icon="control-rewind" icon-class="text-danger"></tile>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="products" label="Producten" icon="tag" icon-class="text-Pulse"></tile>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="users" label="Gebruikers" icon="people" icon-class="text-corporate"></tile>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="sales-channels" label="Verkoopkanalen" icon="share" icon-class="text-success"></tile>
      </div>
      <div class="col-6 col-md-4 col-xl-2">
        <tile route="settings" label="Instellingen" icon="wrench" icon-class="text-elegance"></tile>
      </div>
    </div>
  </div>
</template>
<script>
import Tile from '../common/Tile'

export default {
  components: {Tile}
}
</script>


// WEBPACK FOOTER //
// AdminDashboard.vue?3885b942